import { map, union, flatten, uniqBy } from "lodash"
import { transformArrayInSelect } from "Utils/select.js"

const defaultListStatusControlVisibility = ["published"]
const listStatusControlIsVisible99 = [
  "readyToBeAnswered",
  "waitingForClientDocuments",
  "waitingForDocumentValidation",
]
const listStatusControlIsVisibleLyra = ["published", "draft"]

const mappingTag_StatusVisibility = {
  "99advisory": listStatusControlIsVisible99,
  lyra: listStatusControlIsVisibleLyra,
}

export const getListTemplateAndControlVisible = (fullControlList, businessTag) => {
  if (!Array.isArray(fullControlList)) return []
  let newList = [...fullControlList]
  newList = newList.filter(fullControl => {
    const controlStatus = getStatusFullControl(fullControl)
    const isVisible = fullControlIsVisibleOnPlanning(controlStatus, businessTag)
    const isArchived = fullControlIsArchived(fullControl)
    return isVisible && !isArchived
  })
  return newList
}

const getStatusFullControl = fullControl => {
  const control = fullControl.control || {}
  const template = fullControl.template || {}
  let status = ""
  if (control.hasOwnProperty("status")) status = control.status
  else if (template.hasOwnProperty("statut")) status = template.statut
  return status
}

const getListStatusVisibleFromTag = businessTag => {
  if (Object.keys(mappingTag_StatusVisibility).includes(businessTag)) {
    return mappingTag_StatusVisibility[businessTag]
  }
  return defaultListStatusControlVisibility
}

const fullControlIsVisibleOnPlanning = (controlStatus, businessTag) => {
  let planningVisibleStatus = getListStatusVisibleFromTag(businessTag)
  return planningVisibleStatus.includes(controlStatus)
}

const fullControlIsArchived = fullControl => {
  const templateIsArchived = fullControl?.template?.isArchived
  const controlIsArchived = fullControl?.control?.isArchived
  return templateIsArchived || controlIsArchived
}

export const getListConformite = (governanceType, trad) => {
  const listConformiteMappingRisk = [
    { value: "Conforme", label: trad?.filterlabelConforme },
    { value: "Non Conforme", label: trad?.filterlabelNonConforme },
  ]

  const listConformiteControlPlan = [
    { value: "Conforme", label: trad?.CONFORM },
    { value: "Non Conforme", label: trad?.NOT_CONFORM },
    { value: "Partiellement conforme avec un faible impact", label: trad?.LOW_CONFORM },
    { value: "Partiellement conforme avec un fort impact", label: trad?.STRONG_CONFORM },
    { value: "NA", label: "NA" },
  ]

  if (governanceType === "controlPlan") return listConformiteControlPlan
  else return listConformiteMappingRisk
}

export const getListStatus = (governanceType, trad) => {
  const listStatusMappingRisk = [
    { value: "published", label: trad?.NOT_STARTED },
    { value: "draft", label: trad?.IN_PROGRESS },
    { value: "validated", label: trad?.ENDED },
  ]

  const listStatusControlPlan = [
    { value: "readyToBeAnswered", label: trad?.NOT_STARTED },
    { value: "draft", label: trad?.IN_PROGRESS },
    { value: "validated", label: trad?.AWAITING_VALIDATION_MANAGER },
    { value: "validatedByManager", label: trad?.AWAITING_VALIDATION_CUSTOMER },
    { value: "validatedByClient", label: trad?.ENDED },
  ]

  if (governanceType === "controlPlan") return listStatusControlPlan
  else return listStatusMappingRisk
}

export const getListProcess = fullControls => {
  if (!Array.isArray(fullControls)) return []
  return fullControls.map(fullControl => {
    return {
      value: fullControl?.control?._id?.$oid,
      label: `${fullControl?.control?.reference} - ${fullControl?.control?.process}`,
    }
  })
}

export const getControlFilterOptions = occurrences => {
  if (!Array.isArray(occurrences)) return []
  const mappingId_Name = occurrences.reduce((acc, occu) => {
    const { controlId, controlReference, controlProcess } = occu
    return { ...acc, [controlId]: `${controlReference} - ${controlProcess}` }
  }, {})

  return Object.entries(mappingId_Name).map(entry => {
    const [id, controlName] = entry
    return { value: id, label: controlName }
  })
}

export const useRedirectToAnomalyCreation = (myBusiness, userRoleId) => {
  const businessAccess = myBusiness?.businessAccess
  if (!Array.isArray(businessAccess)) return false
  const userRole = businessAccess.find(role => role.accessId === userRoleId)
  const userCanUseAnomalyRedirection =
    userRole?.accessIncidentManagement && userRole?.createIncident
  const businessUseAnomalyRedirection = myBusiness?.paramsControls?.useAutomaticRedirectionAnomaly
  return userCanUseAnomalyRedirection && businessUseAnomalyRedirection
}

export const getListConformiteWithScaleConformity = (
  conformityScales,
  defaultConformityOptions
) => {
  if (!Array.isArray(conformityScales) && !Array.isArray(defaultConformityOptions)) return []
  if (!Array.isArray(conformityScales) || conformityScales.length === 0)
    return defaultConformityOptions

  let elementLabels = {}

  conformityScales.forEach(conformityScale => {
    const elements = conformityScale?.elements || []
    elements.forEach(elem => {
      elementLabels[elem.label] = elem.label
    })
  })
  defaultConformityOptions.forEach(({ value, label }) => {
    elementLabels[value] = label
  })

  return Object.entries(elementLabels).map(([value, label]) => ({ value, label }))
}

export const getConformityOptions = (
  governanceType,
  trad,
  conformityScales,
  useConformityScale
) => {
  const defaultConformityOptions = getListConformite(governanceType, trad)
  if (!useConformityScale) return defaultConformityOptions

  return getListConformiteWithScaleConformity(conformityScales, defaultConformityOptions)
}
